import SafeUtil from '../../util/SafeUtil';
import BaseEntity from '../base/BaseEntity';

export default class HaStatus extends BaseEntity {
  static URL_STATUS = '/api/ha/status';

  takeover: boolean = false;
  role: string = '';
  message: string = '';

  constructor(reactComponent?: React.Component) {
    super(reactComponent);
  }

  assign(obj: any) {
    super.assign(obj);
  }

  getTAG(): string {
    return 'haStatus';
  }

  // 查询备机是否已接管，触发告警
  httpStatus(
    successCallback?: any,
    errorCallback?: any,
    finalCallback?: any
  ) {
    this.httpPost(
      HaStatus.URL_STATUS,
      {},
      function (response: any) {
        SafeUtil.safeCallback(successCallback)(response.data.data);
      },
      errorCallback,
      finalCallback
    );
  }
}
